import React, { useState } from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
export interface HowToUseCortexBlockProps {}

const HowToUseCortexBlock: React.SFC<HowToUseCortexBlockProps> = () => {
  const commercialCamera = require("../../images/how-use/commercial-camera.svg") as string
  const jetsonNano = require("../../images/how-use/jetson-nano.svg") as string
  const json = require("../../images/how-use/json.jpg") as string
  const [howUse, setHowUse] = useState([
    {
      icon: commercialCamera,
      title: "Recommending the Jetson Nano™",
      description:
        "We recommend using the Jetson Nano™ module, a system-on-module that enables the development of small, low-cost, low-power AI devices. VisualCortex is designed for AI implementation in a variety of industries from smart cities to robotics. Reference:",
      link: " Jetson Nano™ official website",
      animation: "slide-right",
      url:
        "https://www.nvidia.com/en-us/autonomous-machines/embedded-systems/jetson-nano/",
    },
    {
      icon: jetsonNano,
      title: "Commercially Available Cameras",
      description:
        "VisualCortex is designed to work with common webcams available on the market. There is no need to purchase a special, dedicated camera.",
      link: "",
      animation: "slide-up",
      url: "",
    },
    {
      icon: json,
      title: "JSON",
      description:
        `Recognition results can be obtained in JSON (JavaScript Object Notation). It is a lightweight text-based data exchange format that can be used to link data to various external systems. It is also used in "LUDENS," a Human-like AI developed by Cougar.`,
      link: " JSON Official Website",
      animation: "slide-left",
      url: "https://www.json.org/json-en.html",
    },
  ])
  return (
    <div className="container-full block-how-use">
      <h3 className="u-text-center subtitle-section">How to use</h3>
      <p className="block-how-use__text u-text-center">
        A stand-alone, simple, inexpensive system that emphasizes speed and can
        be up and running immediately.
      </p>
      <div className="container">
        <div className="row">
          {howUse.map((item, i) => (
            <div className="col-lg-4 u-margin-tb-1" key={i}>
              <div className="block-how-use__card">
                <img className="image-card" src={item.icon} alt={item.title} />

                <h4 className="u-text-center">{item.title}</h4>
                <p className="u-text-center">
                  {item.description}
                  {item.url === "" ? (
                    <span>{item.link}</span>
                  ) : (
                    <a href={item.url} target="_blank" rel="noreferrer">
                      {item.link}
                    </a>
                  )}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default HowToUseCortexBlock
